import ENUM from '../ENUM'
import ChartType from '../model/CharType'
import RankType from '../model/RankType'

export default function (question) {
    const filters = [
        {
            groupId: 'general',
            name: ENUM().chartType,
            options: ChartType.getOptions('SG'),
        },
        {
            name: ENUM().comparisonSurveyIds,
        },
        {
            name: ENUM().benchmarks,
            options: [
                {
                    label: ENUM().industry,
                    value: 'Industry',
                    name: ENUM().benchmarks,
                },
                {
                    label: ENUM().company,
                    value: 'Company',
                    name: ENUM().benchmarks,
                },
                {
                    label: ENUM().sector,
                    value: 'Sector',
                    name: ENUM().benchmarks,
                },
                {
                    label: ENUM().portfolio,
                    value: 'Portfolio',
                    name: ENUM().benchmarks,
                },
            ],
        },
        {
            groupId: 'general',
            name: ENUM().ranking,
            // first item in array is the default
            options: RankType.getOptions(),
        },
        {
            name: ENUM().locked,
            options: [
                {
                    label: '',
                    value: false,
                    checked: false,
                    name: ENUM().locked,
                },
            ],
            filter: () => (
                question.optionSetX.options.some(({ isLocked }) => isLocked)
                || question.optionSetY.options.some(({ isLocked }) => isLocked)
            ),
        },
    ].filter(({ filter }) => (
        typeof filter !== 'function'
        || filter()
    ))
    return {
        kind: 'QuestionSlide',
        filters,
        references: [ENUM().pageQuestionId],
    }
}
